module.exports = __webpack_public_path__ + "img/833.e9a770ab.svg";